export default __webpack_public_path__ + "static/media/petal_s3.5de2361e.svg";